import { EnrollmentClient } from '../shared/EnrollmentClient';
import { PARAM } from '../../../constants/shared/ApiConstants';
import { ESPANOL_APPLICATION_NAME } from '../../../constants/shared/CommonConstants';

export const { APPLICATION_NAME } = PARAM;

class EspanolEnrollmentClient extends EnrollmentClient {
    getEnrollmentInfoParams = params => [
        `${APPLICATION_NAME}: "${ESPANOL_APPLICATION_NAME}"`,
        ...this.getCommonEnrollmentInfoParams(params),
    ];
}

export default new EspanolEnrollmentClient();
